import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ThankYou() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="thank-you" className="relative flex min-h-[60vh] w-full flex-col items-center justify-center overflow-hidden bg-background px-6 py-24">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,var(--background)_40%,color-mix(in_srgb,var(--secondary),transparent_96%)_100%)]" />

      <div ref={ref} className={cn("relative z-10 flex max-w-lg flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0")}>
        {}
        {}
        <div className="mb-8 flex items-center justify-center">
          <Check className="size-24 text-ring" strokeWidth={0.75} aria-hidden="true" />
        </div>

        {}
        <h2 className="mb-4 font-serif text-4xl font-medium text-primary md:text-5xl">
          Review Received
        </h2>

        {}
        <p className="mb-10 text-lg !text-[hsl(0,0%,0%)]">
          Thank you for your feedback. We appreciate your time and input.
        </p>

        {}
        <Button asChild variant="outline" className="border-ring/20 text-primary hover:bg-ring/5 hover:text-ring hover:border-ring/50 transition-colors">
          <Link to="/">Return to Home</Link>
        </Button>
      </div>
    </section>;
}